import React from 'react'
import styled from 'styled-components'
import Colors from '../../assets/styles/Colors'
import Responsive from '../../assets/config/Responsive'
import DoubleStartIcon from '../../assets/v2/JSX/DoubleStartIcon'
import ToggleSwitcher from './buttons/ToggleSwitcher'
//
//
const GetBetterOffer: React.FC<{
  style?: React.CSSProperties
  title?: string
  description?: string
  text?: string
  onChange?: (_: boolean) => void
  disabled?: boolean
  defaultValue?: boolean | undefined
}> = ({ style, title, description, onChange, disabled = false, defaultValue }) => {
  //
  //
  return (
    <Wrapper style={style} $disabled={disabled}>
      <Left>
        <DoubleStartIconStyle />
        <Texts>
          <span>{title}</span>
          <span>{description}</span>
        </Texts>
      </Left>
      <Right>
        <ToggleSwitcher defaultValue={defaultValue} onChange={(value) => onChange?.(value)} />
      </Right>
    </Wrapper>
  )
}
//
const DoubleStartIconStyle = styled(DoubleStartIcon)`
  height: 40px;
  width: 44px;
`
const Texts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 14px;

  span {
    font-size: 14px;
    color: ${Colors.primaryBlack};

    &:last-child {
      color: ${Colors.nevadaGrey};
    }
  }
`
const Right = styled.div`
  display: grid;
  place-items: center;
`
const Left = styled.div`
  display: flex;
  align-items: center;
`
const Wrapper = styled.div<{ $disabled: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${Colors.lightGrey};
  border-radius: 4px;
  padding: 16px 24px;

  user-select: ${({ $disabled }) => ($disabled ? 'none' : 'unset')};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'unset')};
  opacity: ${({ $disabled }) => ($disabled ? '0.8' : 'unset')};

  ${Responsive.mobile} {
    padding: 16px 20px;
  }
`
//
export default GetBetterOffer
